import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthenticationGuard } from './guards/authentication/authentication.guard';
import { LoggedOnGuard } from './guards/logged-on/logged-on.guard';

import { AuthLayoutComponent } from './components/authentication/auth-layout/auth-layout.component';
import { LoginComponent } from './components/authentication/login/login.component';

import { LayoutComponent } from './components/layout/layout.component';
import { AddInventoryComponent } from './components/inventory/add-inventory/add-inventory.component';
import { UpdateInventoryComponent } from './components/inventory/update-inventory/update-inventory.component';
import { RuleListComponent } from './components/rules/rule-list/rule-list.component';
import { RuleDetailComponent } from './components/rules/rule-detail/rule-detail.component';
import { DeviceInventoryComponent } from './components/device-management/device-inventory/device-inventory.component';
import { DeviceInventoryListComponent } from './components/device-management/device-inventory/list/device-inventory-list.component';
import { CustomerDetailsComponent } from './components/customer-details/customer-details.component';
import { CustomerListComponent } from './components/customer-list/customer-list.component';
import { CustomerEditComponent } from './components/customer-edit/customer-edit.component';

const routes: Routes = [
  {
    path: 'auth',
    component: AuthLayoutComponent,
    children: [
      {
        path: 'login',
        component: LoginComponent,
        canActivate: [LoggedOnGuard]
      },
      {
        path: '**',
        redirectTo: 'login',
        pathMatch: 'full'
      }
    ]
  },
  {
    path: 'app',
    component: LayoutComponent,
    children: [
      {
        path: 'inventory/add',
        component: AddInventoryComponent,
        canActivate: [AuthenticationGuard]
      },
      {
        path: 'inventory/edit',
        component: UpdateInventoryComponent,
        canActivate: [AuthenticationGuard]
      },
      {
        path: 'rules',
        canActivate: [AuthenticationGuard],
        children: [
          {
            path: '',
            component: RuleListComponent,
            canActivate: [AuthenticationGuard]
          },{
            path: 'add-new',
            component: RuleDetailComponent,
            canActivate: [AuthenticationGuard]
          },{
            path: ':id',
            component: RuleDetailComponent,
            canActivate: [AuthenticationGuard]
          },{
            path: '**',
            pathMatch: 'full',
            redirectTo: ''
          }
        ]
      },
      {
        path: '**',
        redirectTo: 'inventory/add',
        pathMatch: 'full'
      }
    ]
  },
  {
    path: 'landing',
    component: LayoutComponent,
    children: [
      {
        path: 'common-inventory/add',
        component: DeviceInventoryComponent,
        canActivate: [AuthenticationGuard]
      },
      {
        path: 'common-inventory/all',
        component:DeviceInventoryListComponent,
        canActivate: [AuthenticationGuard]
      },
      {
        path: 'customer-details',
        component: CustomerDetailsComponent,
        canActivate: [AuthenticationGuard]
      },
      {
        path: 'customer-edit/:id',
        component: CustomerEditComponent,
        canActivate: [AuthenticationGuard]
      },
      {
        path: 'customer-list',
        component: CustomerListComponent,
        canActivate: [AuthenticationGuard]
      },
      {
        path: '**',
        redirectTo: 'customer-list',
        pathMatch: 'full'
      }
    ]
  },
  {
    path: '**',
    redirectTo: 'auth',
    pathMatch: 'full'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
